module.exports = __webpack_public_path__ + "media/images/shared/arrow-white-left-large-ec02d66979684c66243d5179f1c1ac53.png";